import { css } from 'twin.macro';
import React, { useState, Fragment, useMemo, useEffect } from 'react';

//Helpers
import { SanitizeHTML } from '../../../_helpers';

//components
import FileMessage from '../Common/FileMessage';
import ReplyFile from '../Common/ReplyFile';
import SeenByDiv from './SeenByDiv';
import AvatarUserPanel from '../Common/AvatarUserPanel';

//Styles
import { msgContainer } from './styles/MessageStyles';

// icons
import ImagesMessage from '../Common/Messages/ImagesMessage';
import FilesMessage from '../Common/Messages/FilesMessage';
import MessageReactionCounters from '../Message/MessageReactionCounters';
import MessageDetails from '../Message/MessageDetails';
import TextMessageAndSharedLocation from '../Message/TextMessageAndSharedLocation';
import MessageEdited from '../Message/MessageEdited';
import MessageHoverActionContainer from '../Message/MessageHoverOptions/MessageHoverActionContainer';
import { buildReactionCounter } from '../Message/utils/reactionCounter';
import GPTFeedbackMessageHoverActionContainer from '../Message/MessageHoverOptions/GPTFeedbackMessageHoverActionContainer';

const ReceiverMessage = ({
    rId,
    teamData,
    setReply,
    position,
    directUser,
    refs,
    roomType,
    handleClick,
    handleMessageClick,
    m,
    currUser,
    userRole,
    handleDeleteMessage,
    showMessageReactions,
    subChannelId,
    subChannelType,
    roomData,
    hideActions = false,
}) => {
    const {
        id,
        file,
        images,
        files,
        type,
        userName,
        dateAndTime,
        user,
        seenBy,
        isEdited,
        reaction,
        yourReaction,
        transcriptions,
    } = m;
    const canDownload = useMemo(() => {
        if (currUser?.role === 'admin') {
            return true;
        } else if (['owner', 'teamManager'].includes(teamData?.role)) {
            return true;
        } else {
            return false;
        }
    }, [currUser, teamData]);
    let messageFile;
    if (file) {
        messageFile = 'file';
    } else if (images && images?.length) {
        messageFile = 'images';
    } else if (files && files?.length) {
        messageFile = 'files';
    }
    const [showActions, setShowActions] = useState(false);
    const mData = m.data;

    const [reactionCounter, setReactionCounter] = useState(() => {
        if (!reaction) return [];
        return buildReactionCounter(reaction, yourReaction, currUser.name);
    });

    useEffect(() => {
        if (!reaction) {
            setReactionCounter([]);
            return;
        }
        setReactionCounter(buildReactionCounter(reaction, yourReaction, currUser.name));
    }, [reaction, yourReaction, currUser.name]);

    const setReplyMessage = (reply, name) => {
        const teampReply = { ...reply };
        if (teampReply.file || teampReply?.files?.length || teampReply?.images?.length) {
            teampReply.name = name;
            try {
                teampReply.data = teampReply.file || teampReply?.images[0] || teampReply?.files[0];
            } catch (err) {
                teampReply.data = 'shared Files';
            }
            setReply(teampReply);
        } else {
            const { text } = JSON.parse(teampReply.data);
            if (text) {
                teampReply.data = text;
                teampReply.name = name;
                setReply(teampReply);
            }
        }
    };

    let displayMessage, lat, lng, displayReply, displayReplyId, displayReplyUser, replyType;
    try {
        const { text, reply, location } = JSON.parse(mData);
        displayMessage = text;
        if (reply) {
            displayReplyId = reply.id;
            displayReply = reply.reply;
            displayReplyUser = reply.replyUser;
            replyType = reply.type;
        }

        if (location) {
            lat = location.latitude;
            lng = location.longitude;
        }
    } catch (e) {
        displayMessage = mData;
        lat = null;
        lng = null;
    }

    return (
        <Fragment key={id}>
            <div css={msgContainer}>
                <div className="messageContainer justifyStart">
                    <div className="msg p-2 mt-2 d-flex flex-row align-items-start" ref={refs[id]}>
                        <div className="px-2 pt-4"> {<AvatarUserPanel item={directUser || user} />}</div>
                        <div className="px-2">
                            <strong className="p-0 m-0 re-rp text-muted small text-capitalize">
                                {(user && user.name) || userName}
                            </strong>
                            <div
                                className="d-flex  pointer"
                                onClick={() => {
                                    handleMessageClick();
                                    setShowActions(!showActions);
                                }}
                                css={css`
                                    .received-msg {
                                        padding: 1rem;
                                    }
                                `}
                            >
                                {type === 'message' ? (
                                    <div className="received-msg">
                                        <MessageEdited msgEdited={isEdited} />
                                        {displayReply && (
                                            <div
                                                className="received-reply-msg"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleClick(displayReplyId);
                                                }}
                                            >
                                                {displayReplyUser}
                                                {replyType === 'message' ? (
                                                    <div className="d-flex p-0 m-0 small">
                                                        <SanitizeHTML html={displayReply} />
                                                    </div>
                                                ) : (
                                                    <div className="d-flex p-0 m-0 small">
                                                        <ReplyFile file={displayReply} />
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <TextMessageAndSharedLocation
                                            displayMessage={displayMessage}
                                            lat={lat}
                                            lng={lng}
                                        />
                                    </div>
                                ) : (
                                    <div className="received-msg m-0 small text-justify ">
                                        {messageFile === 'file' ? (
                                            <FileMessage
                                                file={file}
                                                displayMessage={displayMessage}
                                                documentSettings={canDownload}
                                            />
                                        ) : messageFile === 'images' ? (
                                            <ImagesMessage
                                                images={images}
                                                displayMessage={displayMessage}
                                                css={css`
                                                    color: white !important;
                                                `}
                                                teamDetails={canDownload}
                                                transcriptions={transcriptions}
                                            />
                                        ) : messageFile === 'files' ? (
                                            <FilesMessage
                                                files={files}
                                                displayMessage={displayMessage}
                                                css={css`
                                                    color: white !important;
                                                `}
                                                canDownload={canDownload}
                                            />
                                        ) : null}
                                    </div>
                                )}
                                <div className="d-flex flex-col">
                                    {!hideActions && (
                                        <>
                                            <GPTFeedbackMessageHoverActionContainer
                                                m={m}
                                                setReplyMessage={setReplyMessage}
                                                user={user}
                                                currUser={currUser}
                                                userName={userName}
                                                roomType={roomType}
                                                rId={rId}
                                            />
                                            <MessageHoverActionContainer
                                                m={m}
                                                setReplyMessage={setReplyMessage}
                                                user={user}
                                                userName={userName}
                                                roomType={roomType}
                                                subChannelType={subChannelType}
                                                rId={rId}
                                                subChannelId={subChannelId}
                                                userRole={userRole}
                                                teamData={teamData}
                                                currUser={currUser}
                                                roomData={roomData}
                                                handleDeleteMessage={handleDeleteMessage}
                                                reactionCounter={reactionCounter}
                                                setReactionCounter={setReactionCounter}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                            <MessageReactionCounters
                                id={id}
                                reactionCounter={reactionCounter}
                                currUser={currUser}
                                showMessageReactions={showMessageReactions}
                            />
                            <MessageDetails showActions={showActions} lat={lat} lng={lng} dateAndTime={dateAndTime} />
                        </div>
                    </div>
                </div>
            </div>
            {seenBy?.length > 0 && <SeenByDiv seenBy={seenBy} messageType="other" />}
        </Fragment>
    );
};
export default ReceiverMessage;
